<template>

    <div>
        <header class="portal-content text-center bg-portal-tertiary p-6 py-20 bg-center" :style="`background-image: url(${app.cloudfront_asset_url + account.asset_banner})`" v-if="account.asset_banner">
            <img :src="app.cloudfront_asset_url + account.asset_logo" :alt="account.name" class="mx-auto max-h-24" v-if="account.asset_logo" >
            <img :src="asset('img/logo.svg')" :alt="app.name" class="mx-auto max-h-24" v-else>
        </header>
        <header class="portal-content text-center bg-portal-tertiary text-slate-400 p-6 py-20" v-else>
            <a href="#main_content" name="main_content" tabindex="-1" class="navigation-logo">
                <img :src="app.cloudfront_asset_url + account.asset_logo" :alt="account.name" class="mx-auto max-h-24" v-if="account.asset_logo" >
                <img :src="asset('img/logo.svg')" :alt="app.name" class="mx-auto max-h-24" v-else>
            </a>
        </header>

        <main role="main" class="portal-content mx-auto p-6 py-12">
            <router-view :app="app" :account="account"></router-view>
        </main>

        <footer class="portal-content text-sm justify-center p-6 py-12 bg-portal-tertiary text-portal-secondary" role="contentinfo">
            <nav>
                <ul class="flex flex-1 mx-auto justify-center">
                    <li class="mr-2"><a href="/privacy" class="text-portal-primary hover:text-portal-primary-lighter" target="_blank">Privacy Policy</a></li>
                    <li class="mr-2"><a href="/terms" class="text-portal-primary hover:text-portal-primary-lighter">Terms of Service</a></li>
                </ul>
            </nav>
            <div class="text-center my-2">
                {{ app.name }} {{ app.version }} &copy; <a :href="app.copyright.name" target="_blank">{{ app.copyright.name }}</a>. <a :href="app.status_url" class="text-portal-primary hover:text-portal-primary-lighter" target="_blank">System Status</a>
            </div>
        </footer>
    </div>

</template>

<script>
import {defineComponent} from "vue";
import {portal} from "../../app/Support/Props";
import {vaporAsset} from "../../app/Support/asset";

export default defineComponent({
    props: portal,
    data() {
        return {
            asset: vaporAsset
        }
    }
});
</script>
